import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import withContent from '../../../containers/withContent';
import paymentDetailsContent, { contentPropTypes } from './IFTPaymentDetails.content';
import { verificationPropTypes } from '../../../states/payments/propTypes';
import { VerticalReviewTable } from 'web-ui-components/lib/layout/tables';
import { getIFTPaymentDetails } from '../../../utils/iftPaymentUtils';

export const IFTPaymentDetails = ({ content: otherContent, payment }) => {
	const paymentDetails = getIFTPaymentDetails(otherContent, payment);

	return <VerticalReviewTable data={paymentDetails} />;
};

IFTPaymentDetails.propTypes = {
	content: PropTypes.shape(contentPropTypes),
	payment: PropTypes.shape(verificationPropTypes),
};

export default compose(withContent({ content: paymentDetailsContent }))(IFTPaymentDetails);
